<template>
<div class="article-medium-header">
    <div class="header"> {{widgetConfig.HeaderText}} </div>
    <div class="divider-line"></div>
</div>
</template>

<script>
export default {
    name: "ArticleMediumHeader",
    props: {
        widgetConfig: Object
    }
}
</script>

<style lang="scss" scoped>
.article-medium-header {
    margin: 16px auto 0px;
    padding: 8px 15px;
    display: flex;
    flex-direction: column;

    .header {
       
        display: flex;
        font-family: $font-family-primary;
        font-size: 26px;
        font-style: normal;
        font-weight: 300;
        line-height: 35px;
        letter-spacing: 0px;
        color: #000000;
        justify-content: center;

    }

    .divider-line {
        width: 120px;
        margin: 16px auto 0px;
        border-bottom: 5px solid $red-primary;
    }

}

@include wide-mobile {

    .article-medium-header {
        padding: 0px;
        margin: 16px 24px;

        .header {
            text-align: center;
        }

         .divider-line {
        width: 36.70%;
    }
    }
}
</style>
